<template>
  <v-layout>
    <app-loader
      title="Загрузка данных Описание товаров"
      :loading="!pageLoaded"
    />
    <v-layout
      v-show="pageLoaded"
      column
    >
      <v-card>
        <v-layout
          row
          wrap
          class="pa-2"
        >
          <v-flex
            xs12
            md4
            class="pr-2"
          >
            <v-layout column>
              <v-flex>
                <v-layout align-center>
                  <v-tooltip bottom>
                    <v-btn
                      slot="activator"
                      small
                      icon
                      class="ma-0"
                      @click="$router.go(-1)"
                    >
                      <v-icon color="grey darken-1">
                        arrow_back
                      </v-icon>
                    </v-btn>
                    <span>Назад</span>
                  </v-tooltip>
                  <h1 class="subheading font-weight-bold px-1">
                    Описание товаров
                  </h1>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip
                        v-if="isShippingActive"
                        text-color="white"
                        class="subheading my-0 mx-2 font-weight-bold"
                        color="red"
                        label
                        small
                        v-on="on"
                      >
                        <v-icon
                          small
                          class="pa-0"
                        >
                          lock
                        </v-icon>&nbsp;АРХИВ
                      </v-chip>
                    </template>
                    <span>{{
                      `Поставка в статусе ${
                        shippingState ? shippingState.title : ""
                      }`
                    }}</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
              <v-flex>
                <span
                  class="pl-1 subheading blue--text text--darken-4"
                >Поставка:</span>
                <router-link
                  :to="{ name: 'shipping', params: { id: shippingId } }"
                  target="_blank"
                >
                  № {{ shippingNumber }}
                </router-link>
                <v-chip
                  text-color="white"
                  class="body-1 my-0 mx-2"
                  color="primary"
                  label
                  small
                >
                  {{ shippingState ? shippingState.title : "Не задан" }}
                </v-chip>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md2
          >
            <v-layout column>
              <v-flex>
                <span
                  class="subheading blue--text text--darken-4"
                >Номер маршрута:&nbsp;</span>
                <v-tooltip
                  v-if="routeNumber"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <span
                      class="subheading font-weight-bold"
                      v-on="on"
                    >{{
                      routeNumber
                    }}</span>
                  </template>
                  <span>Маршрут с пересечением границы</span>
                </v-tooltip>
                <span
                  v-else
                  class="subheading font-weight-bold"
                >Не задан</span>
              </v-flex>
              <v-flex>
                <span
                  class="subheading blue--text text--darken-4"
                >В машине:&nbsp;</span>
                <span class="subheading font-weight-bold">
                  <v-chip
                    text-color="white"
                    class="subheading ma-0"
                    :color="inCarColor"
                    label
                    small
                  >{{ inCar ? "Да" : "Нет" }}</v-chip>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md2
            class="px-2 text-xs-center"
          >
            <v-layout
              column
              class="px-1"
            >
              <v-flex>
                <span
                  class="subheading blue--text text--darken-4"
                >Клиент:&nbsp;</span>
                <span class="subheading font-weight-bold">{{
                  shippingClient
                }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <v-layout>
              <v-flex xs11>
                <v-layout>
                  <v-flex
                    xs6
                    style="text-align: right"
                  >
                    <span
                      class="subheading blue--text text--darken-4 pr-3"
                    >Инфо по поставке:</span>
                  </v-flex>
                  <v-flex xs6>
                    <table
                      style="width: 190px"
                      hide-actions
                    >
                      <tbody>
                        <tr style="height:20px">
                          <td
                            class="blue--text text--darken-4"
                            style="max-width: 120px; min-width: 120px; width: 120px"
                          >
                            Объем, м3:
                          </td>
                          <td class="font-weight-bold text-xs-left">
                            {{ shippingVolume }}
                          </td>
                        </tr>
                        <tr style="height:20px">
                          <td
                            class="blue--text text--darken-4"
                            style="max-width: 120px; min-width: 120px; width: 120px"
                          >
                            Вес брутто, кг:
                          </td>
                          <td class="font-weight-bold text-xs-left">
                            {{ shippingWeightBrutto }}
                          </td>
                        </tr>
                        <tr style="height:20px">
                          <td
                            class="blue--text text--darken-4"
                            style="max-width: 120px; min-width: 120px; width: 120px"
                          >
                            Количество мест:
                          </td>
                          <td class="font-weight-bold text-xs-left">
                            {{ shippingCargoPlace }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs1
                align-self-end
                class="text-xs-rigth"
              >
                <v-layout justify-end>
                  <DownloadXlsxBtn
                    :loading="loadingExcel"
                    @download="downloadOutputForm()"
                  />
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>

      <v-layout
        v-if="compactMode"
        row
        wrap
      >
        <v-flex
          xs12
          md4
        >
          <!-- INFO -->
          <v-card
            class="my-2 pa-2"
            :style="{
              height: `${infoBlockHeight}px`,
              'overflow-y': 'auto',
              'overflow-x': 'hidden'
            }"
          >
            <v-list class="pt-0 pb-0">
              <v-list-tile
                v-for="(property, index) in info"
                :key="index"
                class="compact"
              >
                <v-layout
                  row
                  justify-start
                >
                  <v-flex
                    v-if="
                      property.type !== 'manager-reference' &&
                        property.type !== 'decimal'
                    "
                    xs6
                  >
                    <span
                      class="blue--text text--darken-4"
                    >{{ property.title }}:</span>
                  </v-flex>
                  <v-flex
                    v-if="
                      property.type && property.type === 'manager-reference'
                    "
                    xs12
                  >
                    <ManagerSelect
                      v-model="property.value"
                      :label="property.title"
                      :disabled="isDisabled"
                      :without-clearable="isDescription"
                      class="mt-2 mr-1"
                      @input="
                        property.callback
                          ? property.callback(property.value)
                          : null
                      "
                    />
                  </v-flex>
                  <v-flex
                    v-else-if="property.type && property.type === 'date'"
                    xs6
                  >
                    <span class="mt-1">{{
                      property.value ? property.value : "Не задано"
                    }}</span>
                  </v-flex>
                  <v-flex
                    v-else-if="
                      property.type && property.type === 'text-formatter'
                    "
                    xs6
                    class="mt-0"
                  >
                    <span>{{ factoryMarkings | stringList(true) }}</span>
                  </v-flex>
                  <v-flex
                    v-else-if="property.type && property.type === 'decimal'"
                    xs12
                    class="mt-0"
                  >
                    <v-layout
                      v-if="!loading"
                      align-end
                    >
                      <v-flex xs8>
                        <DecimalEditor
                          v-model="property.value"
                          :label="property.title"
                          scale="2"
                          :disabled="isDisabled"
                          class="mt-2 mr-2"
                          @input="
                            property.callback
                              ? property.callback(property.value)
                              : null
                          "
                        />
                      </v-flex>
                      <v-flex xs4>
                        <CurrencyReference
                          v-model="currencyInvoiceSum"
                          title-for-nested-editor="Валюта"
                          :disabled="isDisabled"
                          class="mr-2"
                          height-item="44"
                          @input="changeCurrency"
                        />
                      </v-flex>
                    </v-layout>
                    <div
                      v-else
                      class="text-xs-center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        size="20"
                        width="2"
                        class="mt-3"
                      />
                    </div>
                  </v-flex>
                  <v-flex
                    v-else
                    xs6
                    style="word-wrap: break-word;"
                  >
                    {{ property.value }}
                  </v-flex>
                </v-layout>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <v-card class="ma-2 pa-2">
            <v-tabs>
              <v-tab
                style="text-transform:none"
                class="tabItemHeight"
              >
                <h2 class="subheading font-weight-bold">
                  Метки
                </h2>
              </v-tab>
              <v-tab
                style="text-transform:none"
                class="tabItemHeight"
              >
                <h2 class="subheading font-weight-bold">
                  Документы
                  <span
                    v-if="attachmentsForExpert.length + attachments.length > 0"
                    class="blue--text text--darken-4"
                  >{{
                    attachmentsForExpert.length + attachments.length
                  }}</span>
                </h2>
              </v-tab>
              <v-tab
                style="text-transform:none"
                class="tabItemHeight"
              >
                <h2 class="subheading font-weight-bold">
                  Заметки
                  <span
                    v-if="notes.length > 0"
                    class="blue--text text--darken-4"
                  >({{ notes.length }})</span>
                </h2>
              </v-tab>
              <!-- LABLES -->
              <v-tab-item
                :style="{
                  height: `${tabItemHeight}px`,
                  'overflow-y': 'auto',
                  'overflow-x': 'hidden'
                }"
              >
                <v-layout>
                  <v-flex xs12>
                    <app-lables
                      :id="id"
                      :disabled="isDisabled"
                      :is-description-in-system="isDescriptionInSystem"
                      :values="goodsDetailLables"
                      :items="items"
                      :is-items-valid="isItemsValid"
                      :categories-items="categoriesInfo"
                      :is-disabled-description-in-system="
                        isDisabledLabelDescriptionInSystem
                      "
                      :tooltip-description-in-system="
                        tooltipLabelDescriptionInSystem
                      "
                      :packages="packages"
                      :is-disabled-description-categories="
                        isDisabledLabelDescriptionCategories
                      "
                      :tooltip-description-categories="
                        tooltipLabelDescriptionCategories
                      "
                      :shipping-accepted="shippingAccepted"
                      :is-disable-description="!isManagerByDescription"
                      class="pa-2"
                      @change="changedLabels"
                    />
                  </v-flex>
                </v-layout>
              </v-tab-item>

              <!-- ATTACHMENTS -->
              <v-tab-item
                :style="{
                  height: `${tabItemHeight}px`,
                  'overflow-y': 'auto',
                  'overflow-x': 'hidden'
                }"
              >
                <v-layout>
                  <v-flex xs12>
                    <Attachments
                      :value="attachmentsForExpert"
                      :block-height="(blockActionsHeight - 150) / 2"
                      :resource="`shippings/${shippingId}`"
                      :disabled="true"
                      :disabled-sender="true"
                      :disabled-upload="true"
                      :disabled-upload-to-server="true"
                      :disabled-download="false"
                      :type="attachmentsType.EXPORT"
                      title="Экспортные документы"
                    />
                    <v-divider class="mt-2" />
                    <Attachments
                      :value="attachments"
                      :block-height="(blockActionsHeight - 150) / 2"
                      :resource="`shippings/${shippingId}`"
                      :disabled="true"
                      :disabled-sender="true"
                      :disabled-upload="true"
                      :disabled-upload-to-server="true"
                      :disabled-download="false"
                      title="Другие документы"
                    />
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item
                :style="{
                  height: `${tabItemHeight}px`,
                  'overflow-y': 'auto',
                  'overflow-x': 'hidden'
                }"
              >
                <v-layout>
                  <v-flex xs12>
                    <Notes
                      :id="id"
                      v-model="notes"
                      :disabled="loadingNotes || isDisabled"
                      @updateNotes="getNotes"
                    />
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md4
        >
          <v-card
            class="my-2 pa-2"
            :style="{ height: `${infoBlockHeight}px` }"
          >
            <CategoriesInfo
              :id="id"
              :total-info="totalInfo"
              :total-categories="totalCategories"
              :items="categoriesInfo"
              :disabled="isDisabled"
              @change="getCategoriesInfo"
            />
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout>
        <!-- ITEMS -->
        <v-flex xs-12>
          <v-card :class="['pa-2', { 'my-2': !compactMode }]">
            <app-goods-detail-items
              v-model="items"
              :can-edit="!isDisabled"
              :total-info="totalInfo"
              :loading="loadingItems"
              :block-height="itemsBlockHeight"
              :compact-mode="compactMode"
              :places-fact="totalCargoPlacesFact"
              :goods-details-id="id"
              :disabled-add-item="isDisabledAddItem"
              @update="updateItem"
              @moveItems="moveItems"
              @deleteItem="deleteItem"
              @addItem="addItem"
              @changeCompactMode="compactMode = !compactMode"
              @updatePlacesFact="updateTotalCargoPlacesFact"
              @getItems="getItems"
              @getCategoriesInfo="getCategoriesInfo"
              @change="updateItems"
            />
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-layout>
</template>

<script>
import GoodsDetailItems from "./components/GoodsDetailItems.vue";
import Lables from "./components/GoodsDetailsLables.vue";
import Attachments from "../../components/attachments/Attachments.vue";
import CategoriesInfo from "./components/CategoriesInfo.vue";
import Notes from "./components/Notes.vue";
import * as goodsDetailsApi from "../../backend/goodsDetailsApi.js";
import { eShippingStates } from "../shippings/shipping-states.js";
import { labelDescriptionVariants } from "./components/label-description-variants.js";
import { routeStates } from "../routes/route-states.js";
import { attachmentsType } from "../../enums/attachments-types.js";

export default {
  components: {
    appGoodsDetailItems: GoodsDetailItems,
    appLables: Lables,
    Attachments,
    CategoriesInfo,
    Notes,
  },
  props: ["id"],
  data() {
    return {
      shippingId: null,
      shippingNumber: null,
      shippingClient: "",
      shippingCargoPlace: 0,
      shippingVolume: 0,
      shippingWeightBrutto: 0,
      shippingState: null,
      info: [],
      inCar: false,
      routeNumber: null,
      items: [],
      labels: [],
      attachments: [],
      attachmentsForExpert: [],
      dataRestored: false,
      relatedDataRestored: false,
      isItemsValid: false,
      totalInfo: null,
      loadingExcel: false,
      currencyInvoiceSum: null,
      loading: false,
      categoriesInfo: [],
      loadingItems: false,
      compactMode: true,
      notes: [],
      loadingNotes: false,
      loadingTotalCargoPlacesFact: false,
      totalCargoPlacesFact: null,
      totalCategories: null,
      packages: [],
      shippingAccepted: false,
      routeState: null,
      isManagerByDescription: false,
      isDescription: false,
    };
  },
  computed: {
    goodsDetailLables() {
      return this.labels;
    },
    itemsBlockHeight() {
      if (this.compactMode) {
        return window.innerHeight - 498;
      } else {
        return window.innerHeight - 210;
      }
    },
    infoBlockHeight() {
      return 288;
    },
    tabItemHeight() {
      return this.infoBlockHeight - 51;
    },
    inCarColor() {
      if (this.routeNumber && this.inCar) {
        return "green";
      } else {
        return "red";
      }
    },
    pageLoaded() {
      return this.relatedDataRestored && this.dataRestored;
    },
    factoryMarkings() {
      return this.items.map(i => i.factoryMarking);
    },
    isDescriptionInSystem() {
      return !!this.labels.find(
        l =>
          l.name === "description" &&
          l.value === labelDescriptionVariants.INSYSTEM,
      );
    },
    isDisabledLabelDescriptionInSystem() {
      return (
        !this.items.length ||
        !this.categoriesInfo.length ||
        this.totalInfo?.totalCargoPlaces !==
          this.totalCategories?.totalCargoPlaces ||
        this.totalInfo?.totalVolume !== this.totalCategories?.totalVolume ||
        this.totalInfo?.totalWeightBrutto !==
          this.totalCategories?.totalWeightBrutto ||
        this.totalCategories?.totalCargoPlaces === 0 ||
        this.totalCategories?.totalVolume === 0
      );
    },
    tooltipLabelDescriptionInSystem() {
      if (!this.items.length || !this.categoriesInfo.length) {
        return "Внесите данные в таблицы Информация о товаре и Категория товара";
      }
      if (
        this.totalInfo?.totalCargoPlaces !==
          this.totalCategories?.totalCargoPlaces ||
        this.totalInfo?.totalVolume !== this.totalCategories?.totalVolume ||
        this.totalInfo?.totalWeightBrutto !==
          this.totalCategories?.totalWeightBrutto
      ) {
        return "Итоги в таблицах Информация о товаре и Категория товара НЕ совпадают";
      }
      if (
        this.totalCategories?.totalCargoPlaces === 0 ||
        this.totalCategories?.totalVolume === 0
      ) {
        return "Укажите Oбъем и Всего мест в таблице Категория товара";
      }
    },
    isDisabledLabelDescriptionCategories() {
      return !this.items.length;
    },
    tooltipLabelDescriptionCategories() {
      if (!this.items.length) {
        return "Внесите данные в таблицу Информация о товаре";
      } else {
        return "";
      }
    },
    isShippingActive() {
      if (
        this.shippingState?.id === this.shippingStates.NotAccepted ||
        this.shippingState?.id === this.shippingStates.CanceledByClient
      ) {
        return true;
      }
      return false;
    },
    isDisabled() {
      if (this.isDescriptionInSystem || this.isShippingActive) {
        return true;
      }
      return false;
    },
    shippingStates() {
      return eShippingStates;
    },
    isDisabledAddItem() {
      return this.routeState?.id === routeStates.UNLOADED;
    },
    attachmentsType() {
      return attachmentsType;
    },
    blockHeight() {
      return window.innerHeight - 246;
    },
    blockActionsHeight() {
      return this.blockHeight - 184;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await goodsDetailsApi.getGoodsDetail(this.id);
      this.shippingId = res.data.Shipping.Id;
      this.shippingNumber = res.data.Shipping.Number;
      this.shippingClient = res.data.Shipping.Client.Title;
      this.shippingCargoPlace = res.data.Shipping.CargoPlace || 0;
      this.shippingWeightBrutto = res.data.Shipping.WeightBrutto || 0;
      this.shippingVolume = res.data.Shipping.Volume || 0;
      this.shippingState = res.data.Shipping.State
        ? {
          id: res.data.Shipping.State.Id,
          title: res.data.Shipping.State.Title,
        }
        : null;
      this.isItemsValid = res.data.IsItemsValid;
      this.routeNumber = res.data.RelatedInfo.Number;
      this.inCar = res.data.RelatedInfo.InCar;
      this.relatedDataRestored = true;
      this.currencyInvoiceSum = res.data.Shipping.Currency
        ? {
          id: res.data.Shipping.Currency.Id,
          title: res.data.Shipping.Currency.Title,
        }
        : null;
      (this.totalCargoPlacesFact = res.data.PlacesFact
        ? res.data.PlacesFact
        : null),
      this.getInfo(res.data);
      this.labels = [
        { name: "description", value: res.data.Description },
        { name: "fragile", value: res.data.Fragile, type: "boolean" },
        { name: "mesurable", value: res.data.Mesurable },
        {
          name: "definitionCategories",
          value: res.data.DefinitionCategories,
          type: "boolean",
        },
        {
          name: "parseByOrders",
          value: res.data.ParseByOrders,
          type: "boolean",
        },
        {
          name: "ex",
          value: [
            { name: "exWhoDoing", value: res.data.EX.ExWhoDoing },
            {
              name: "exDocumentInSystem",
              value: res.data.EX.ExDocumentInSystem,
            },
          ],
          group: true,
        },
        {
          name: "invoice",
          value: res.data.Invoice,
          type: "boolean",
        },
      ];
      this.isDescription = !!res.data.Description;

      this.packages =
        res.data.Shipping.Packages && res.data.Shipping.Packages.length
          ? res.data.Shipping.Packages.map(p => {
            return {
              title: p.Title,
              shortTitle: p.ShortTitle,
              color: p.Color,
            };
          })
          : [];

      this.attachments = res.data.Shipping.Attachments.map(a => {
        return {
          id: a.Id,
          title: a.Title,
        };
      });

      this.attachmentsForExpert = res.data.Shipping.AttachmentsForExport.map(
        a => {
          return {
            id: a.Id,
            title: a.Title,
          };
        },
      );

      this.notes = res.data.Notes
        ? res.data.Notes.map(n => {
          return {
            id: n.Id,
            text: n.Text,
            author: n.Author,
            changedAt: n.ChangedAt,
          };
        })
        : [];
      this.shippingAccepted = res.data.Shipping.Accepted;
      this.routeState = res.data.RelatedInfo.RouteState
        ? {
          id: res.data.RelatedInfo.RouteState.Id,
          title: res.data.RelatedInfo.RouteState.Title,
        }
        : null;
      await this.getItems();
      await this.getCategoriesInfo();
      this.dataRestored = true;
    },
    async getItems() {
      this.loadingItems = true;
      const items = await goodsDetailsApi.getGoodsDetailsItems(this.id);
      await this.getCategoriesInfo();
      this.loadingItems = false;
      this.items = items.items;
      this.totalInfo = items.totalInfo;
    },
    async updateItems() {
      const updateItemsList = this.items.map(i => {
        return {
          id: i.id ? i.id : 0,
          articleId: i.article ? i.article.id : null,
          countryId: i.country ? i.country.id : null,
          goodSite: i.goodSite,
          material: i.material,
          modelId: i.model ? i.model.id : null,
          nomenclatureId: i.nomenclature ? i.nomenclature.id : null,
          places: i.places ? i.places : 0,
          quantity: i.quantity ? i.quantity : 0,
          trademarkId: i.trademark ? i.trademark.id : null,
          size: i.size,
          unitId: i.unit ? i.unit.id : null,
          weightBrutto: i.weightBrutto ? i.weightBrutto : 0,
          weightNetto: i.weightNetto ? i.weightNetto : 0,
          volume: i.volume ? i.volume : 0,
          fragile: i.fragile,
          factoryMarking: i.factoryMarking,
          productCategoryId: i.productCategory ? i.productCategory.id : null,
          notes: i.notes,
          cost: i.cost ? i.cost : 0,
          customsNumber: i.customsNumber ? i.customsNumber : "",
        };
      });
      this.loadingItems = true;
      await goodsDetailsApi.updateGoodsDetailsItems(this.id, updateItemsList);
      this.loadingItems = false;
      this.getItems();
      this.getCategoriesInfo();
      this.showInfo("Изменения сохранены");
    },
    getInfo(data) {
      this.info = [
        {
          title: "План. дата прохождения границы",
          value: data.RelatedInfo.PassingBorderDatePlan
            ? this.$options.filters.date(data.RelatedInfo.PassingBorderDatePlan)
            : "Не задана",
          type: "date",
        },
        {
          title: "План. дата затаможки",
          value: data.RelatedInfo.CustomsRegistrationDatePlan
            ? this.$options.filters.date(
              data.RelatedInfo.CustomsRegistrationDatePlan,
            )
            : "Не задана",
          type: "date",
        },
        {
          title: "Менеджер",
          value: data.Shipping.Manager?.Title || null,
        },
        {
          title: "Продавец",
          value: data.Shipping.Factory
            ? data.Shipping.Factory.Title
            : "Не указан",
        },
        {
          title: "Маркировка на фабрике",
          value: data.Shipping.FactoryMarking,
          type: "text-formatter",
          callback: this.changeFactoryMarking,
        },
        {
          title: "Описание из поставки",
          value: data.Shipping.ProductDescription,
        },
        {
          title: "Референс погрузки",
          value: data.Shipping.LoadingNumber,
        },
        {
          title: "Менеджер по описанию",
          value: data.Shipping.ManagerByDescription
            ? {
              id: data.Shipping.ManagerByDescription.Id,
              title: data.Shipping.ManagerByDescription.Title,
            }
            : null,
          type: "manager-reference",
          callback: this.changeManagerByDescription,
        },
        {
          title: "Стоимость партии груза",
          value: data.InvoiceSum,
          type: "decimal",
          callback: this.changeInvoiceSum,
        },
      ];
      this.isManagerByDescription = data.Shipping.ManagerByDescription
        ? true
        : false;
    },
    async changeManagerByDescription(newValue) {
      await goodsDetailsApi.changeManagerByDesription(this.id, newValue);
      this.isManagerByDescription = newValue ? true : false;
      this.showInfo("Менеджер по описанию изменен");
    },
    async changeFactoryMarking(newValue) {
      if (!newValue) {
        return;
      }
      await goodsDetailsApi.changeFactoryMarking(this.id, newValue);
    },
    async moveItems(items, itemId, position) {
      this.items = items;
      await goodsDetailsApi.changeItemPosition(this.id, itemId, position);
      this.getItems();
    },
    async deleteItem(itemId) {
      if (!itemId) {
        return;
      }
      await goodsDetailsApi.deleteItem(this.id, itemId);
      this.getItems();
    },
    async addItem(items = []) {
      const itemsArray = Array.isArray(items) ? items : [items];

      if (itemsArray.length === 0) {
        return;
      }

      this.loadingItems = true;

      for (const item of itemsArray) {
        const newItem = {
          articleId: item.article ? item.article.id : null,
          countryId: item.country ? item.country.id : null,
          goodSite: item.goodSite,
          material: item.material,
          modelId: item.model ? item.model.id : null,
          nomenclatureId: item.nomenclature ? item.nomenclature.id : null,
          places: item.places ? item.places : 0,
          quantity: item.quantity ? item.quantity : 0,
          trademarkId: item.trademark ? item.trademark.id : null,
          unitId: item.unit ? item.unit.id : null,
          weightBrutto: item.weightBrutto ? item.weightBrutto : 0,
          weightNetto: item.weightNetto ? item.weightNetto : 0,
          volume: item.volume ? item.volume : 0,
          fragile: item.fragile,
          factoryMarking: item.factoryMarking,
          size: item.size,
          productCategoryId: item.productCategory
            ? item.productCategory.id
            : null,
          notes: item.notes,
          cost: item.cost ? item.cost : 0,
          customsNumber: item.customsNumber ? item.customsNumber : "",
        };

        await goodsDetailsApi.addItem(this.id, newItem);
      }

      this.loadingItems = false;
      this.getItems();
      this.getCategoriesInfo();
      this.showInfo("Информацию о товаре сохранено");
    },
    async downloadOutputForm() {
      this.loadingExcel = true;
      const response = await goodsDetailsApi.downloadOutputForm(this.id);
      this.downloadAsExel(response.data);
      this.loadingExcel = false;
    },
    downloadAsExel(fileData) {
      const textInfo = `Описание товаров_${this.shippingNumber}`;
      const blob = new Blob([fileData], { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${textInfo}.xlsx`;
      link.click();
    },
    async changeInvoiceSum(newValue) {
      if (!newValue) {
        return;
      }
      this.loading = true;
      await goodsDetailsApi.changeInvoiceSum(this.id, newValue);
      this.loading = false;
      this.showInfo("Стоимость партии груза изменена");
    },
    async getCategoriesInfo() {
      this.loading = true;
      const categories = await goodsDetailsApi.getCategoriesInfo(this.id);
      this.categoriesInfo = categories;
      this.totalCategories = {
        totalCargoPlaces: categories.reduce(function(sum, current) {
          const result = sum + current.cargoPlaces;
          return +result.toFixed(3);
        }, 0),
        totalVolume: categories.reduce(function(sum, current) {
          const result = sum + current.volume;
          return +result.toFixed(3);
        }, 0),
        totalWeightBrutto: categories.reduce(function(sum, current) {
          const result = sum + current.weightBrutto;
          return +result.toFixed(3);
        }, 0),
      };
      this.loading = false;
    },
    async changeCurrency(newValue) {
      if (!newValue) {
        return;
      }
      this.loading = true;
      await goodsDetailsApi.changeCurrency(this.id, newValue.id);
      this.loading = false;
      this.showInfo("Валюта изменена");
    },
    async getNotes() {
      this.loadingNotes = true;
      this.notes = await goodsDetailsApi.getNotes(this.id);
      this.loadingNotes = false;
    },
    async updateTotalCargoPlacesFact(totalCargoPlacesFact) {
      this.loadingTotalCargoPlacesFact = true;
      await goodsDetailsApi.updateTotalCargoPlacesFact(
        this.id,
        totalCargoPlacesFact,
      );
      this.loadingTotalCargoPlacesFact = false;
      this.showInfo("Поле всего мест факт изменено");
    },
    changedLabels(labels) {
      this.labels = [
        { name: "description", value: labels.description.value },
        { name: "fragile", value: labels.fragile.value, type: "boolean" },
        { name: "mesurable", value: labels.mesurable.value },
        {
          name: "definitionCategories",
          value: labels.definitionCategories.value,
          type: "boolean",
        },
        {
          name: "parseByOrders",
          value: labels.parseByOrders.value,
          type: "boolean",
        },
        {
          name: "ex",
          value: labels.ex.value,
        },
        {
          name: "invoice",
          value: labels.invoice.value,
          type: "boolean",
        },
      ];
      this.isDescription = !!labels.description.value;
    },
    async updateItem(updateItem) {
      this.loadingItems = true;
      const item = {
        id: updateItem.id,
        trademarkId: updateItem.trademark?.id,
        modelId: updateItem.model?.id,
        nomenclatureId: updateItem.nomenclature?.id,
        articleId: updateItem.article?.id,
        material: updateItem.material,
        goodSite: updateItem.goodSite,
        countryId: updateItem.country?.id,
        productCategoryId: updateItem.productCategory?.id,
        unitId: updateItem.unit?.id,
        quantity: updateItem.quantity,
        places: updateItem.places,
        size: updateItem.size,
        weightNetto: updateItem.weightNetto,
        weightBrutto: updateItem.weightBrutto,
        volume: updateItem.volume,
        fragile: updateItem.fragile,
        factoryMarking: updateItem.factoryMarking,
        customsNumber: updateItem.customsNumber,
        cost: updateItem.cost,
        notes: updateItem.notes,
      };
      await goodsDetailsApi.updateGoodsDetailsItem(
        this.id,
        updateItem.id,
        item,
      );
      this.loadingItems = false;
      this.getItems();
      this.getCategoriesInfo();
      this.showInfo("Информацию о товаре сохранено");
    },
  },
};
</script>

<style>
.v-tabs__wrapper .v-tabs__container {
  height: 35px;
}
.v-tabs__container .v-tabs__div .v-tabs__item {
  align-items: flex-end;
}
table.v-table tfoot tr td {
  padding: 0 5px !important;
}
.layout .v-chip.v-chip--label.v-chip--small {
  height: 19px;
}
</style>
